export default {
    DATE_PICKER_DATE_FORMAT: "dd-MM-yyyy",
    DATE_FORMAT: "YYYY-MM-DD",
    REQUIRED_MESSAGE: "Required!"
}